import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { companyApi } from "../../api/company";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";

export default function Downland() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");
  const [companyData, setCompanyData] = useState({} as any);
  //初始化获取公司
  async function initCompany() {
    const res = await companyApi.domain();
    if (res.ok) {
      setCompanyData(res.data);
    }
  }
  useEffect(() => {
    initCompany();
  }, []);
  return (
    <div className="revert-style w-full bg-neutral-900 min-h-screen">
      <AcendexLayout
        theme="light"
        mobileTopBarTitle={
          "App" + (lan == "zh" ? "" : " ") + translate(getText("下載"))
        }
        pcTopBarTitle={
          "App" + (lan == "zh" ? "" : " ") + translate(getText("下載"))
        }
        hideBottomBar
      >
        <div className="max-w-4xl mx-auto px-4 py-6 bg-neutral-900">
          <CenterPage companyData={companyData} />
        </div>
      </AcendexLayout>
    </div>
  );
}
